/**
 * Instruction from mui doc
 * ==============================
 * Ref: https://mui.com/material-ui/customization/theming/
 * Theme composition: using theme options to define other options
 * When the value for a theme option is dependent on another theme option, you should compose the theme in steps.
 */

//TODO:: custom venue horizontal kiosk style later
export const venueKioskHUIThemeOptionFactory = (theme) => ({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          lineHeight: 1.45,
        },
        sizeSmall: {
          fontSize: 18,
          padding: theme.spacing(1, 2),
        },
        sizeMedium: {
          fontSize: 20,
          padding: theme.spacing(2, 2.5),
        },
        sizeLarge: {
          fontSize: 24,
          padding: theme.spacing(2, 5),
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        sizeLarge: {
          padding: theme.spacing(5, 6),
          "& .MuiSvgIcon-root": {
            width: 40,
            height: 40,
          },
        },
      },
    },

    /**
     * VenueUI (Vui) - Horizontal Kiosk
     * Extra Component for venue.in.th projects
     */

    VuiNavigationControl: {
      styleOverrides: {
        wrapper: {
          height: 107,
          display: "flex",
          flexDirection: "row",
          width: "100%",
        },
        navigationAction: {
          padding: theme.spacing(3),
        },
      },
    },
    VuiSearchBasePopup: {
      styleOverrides: {
        dialog: {
          width: "65vw", //  Page content width
          top: theme.spacing(15.75), // Top padding for content page (20px) + Header height (106px)
          left: theme.spacing(4.125), // Content page padding: 33px
          bottom: theme.spacing(2.5), // Bottom padding for content page: 20px
          "& .MuiBackdrop-root": {
            position: "absolute",
            borderRadius: "15px",
            "&:after": {
              position: "fixed",
              display: "flex",
              content: "''",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            },
          },
        },
        dialogPaper: {
          margin: theme.spacing(1.75),
          maxWidth: "1086px",
          background: "transparent",
          boxShadow: "none",
        },
        dialogContent: {
          display: "flex",
          padding: 0,
          flexDirection: "column",
          gap: theme.spacing(2),
          // Apply a className to each section for ordering.
          "& .VuiSearchResult-root": {
            order: 0,
          },
          "& .VuiSearchPopupContent-searchBar": {
            order: 1,
          },
          "& .VuiSearchKeyboard-root": {
            order: 9999,
          },
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        root: {
          flexGrow: 1,
          width: "100%",
          overflow: "hidden",
        },
        rootDialog: {
          position: "relative",
          backgroundColor: theme.palette.background.paper,
          // TODO: Update the height to 413px when adding category quick search.
          height: "613px",
          borderRadius: "20px",
          padding: theme.spacing(9.75, 8.5, 0),
          "&:after": {
            display: "flex",
            pointerEvents: "none",
            content: "''",
            width: "100%",
            height: "147px",
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(0deg, ${theme.palette.common.white} 9.97%, transparent 72.39%)`,
          },
        },
        list: {
          display: "flex",
          flexDirecton: "row",
          flexWrap: "wrap",
          margin: "0 auto",
          gap: theme.spacing(2),
        },
        listItem: {
          padding: 0,
          width: "296px",
        },
      },
    },
    VuiSearchPopupContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 5.5),
          backgroundColor: "transparent",
        },
        dialogPaper: {
          alignSelf: "center",
        },
        closeButton: {
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 1,
          marginTop: theme.spacing(3),
          marginRight: theme.spacing(3),
          padding: theme.spacing(2),
          width: "2.9rem",
          height: "2.9rem",
          color: theme.palette.primary.main,
        },
        closeButtonIcon: {
          width: "2rem",
          height: "2rem",
        },
        searchInput: {
          fontSize: "1.25rem",
          gap: theme.spacing(10),
          borderRadius: "9999px",
          padding: theme.spacing(1, 6),
          "& .MuiInputAdornment-root": {
            "& .MuiSvgIcon-root": {
              color: "#cccccc",
            },
          },
        },
      },
    },
    VuiSearchKeyboard: {
      styleOverrides: {
        root: {
          margin: theme.spacing(0, 5.5),
          borderRadius: "20px",
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        image: {
          width: "50%",
          margin: "0 auto",
          [theme.breakpoints.up("sm")]: {
            width: "50%",
            margin: "0 auto",
          },
        },
        infoListItem: {},
      },
    },
    VuiOnscreenKeyboard: {
      styleOverrides: {
        root: {
          // [Example] (https://hodgef.com/simple-keyboard/editor/?d=hodgef/react-simple-keyboard-demos/tree/uc-customization)
          // Add your custom style here
          "& .simple-keyboard": {
            maxWidth: "100%",
            padding: theme.spacing(1),
            backgroundColor: "transparent",
            "& .hg-rows": {
              width: "660px",
              margin: "0 auto",
            },
            "&.hg-theme-default .hg-row": {
              marginBottom: theme.spacing(0.75),
              "&:last-child": {
                marginBottom: 0,
              },
              "& .hg-button:not(:last-child)": {
                marginRight: theme.spacing(1.5),
              },
            },
            "& .hg-button": {
              height: 42,
              width: 50,
              backgroundColor: theme.palette.common.black,
              color: theme.palette.common.white,
              fontSize: "25px",
              fontWeight: 500,
              borderRadius: "6px",
              "&.hg-standardBtn": {
                width: 50,
              },
            },
            "& .hg-secondary-button": {
              backgroundColor: theme.palette.text.secondary,
              color: theme.palette.primary.contrastText,
            },
          },
        },
      },
    },
    VuiFilterVenueRadioButtons: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          width: "100%",
          gap: theme.spacing(5),
          justifyContent: "center",
          textTransform: "uppercase",
        },
        labelImage: {
          height: "32px",
        },
      },
    },
  },
})
